// import { RequireAutorization } from './routerAuth'

export default {
  path: '/planos',
  component: () => import(/* webpackChunkName: "Plans" */ '@apps/plans/Layout.vue'),
  children: [
    {
      path: 'criar',
      name: 'PlanNew',
      component: () => import(/* webpackChunkName: "Plans" */'@apps/plans/New.vue'),
      meta: { title: 'Criar Plano' },
    },
    {
      path: '',
      name: 'Plans',
      component: () => import(/* webpackChunkName: "Plans" */'@apps/plans/Index.vue'),
      meta: { title: 'Planos' },
      children: [
        {
          path: ':id',
          name: 'PlanShow',
          component: () => import(/* webpackChunkName: "Plans" */'@apps/plans/Show.vue'),
          meta: { title: 'Exibir Plano' },
        },
      ],
    },
    {
      path: ':id/editar',
      name: 'PlanEdit',
      component: () => import(/* webpackChunkName: "Plans" */'@apps/plans/Edit.vue'),
      meta: { title: 'Editar Plano' },
    },
  ],
  // beforeEnter: RequireAutorization
}
